import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import { PauseIcon, PlayIcon } from 'assets/icons'
import Card from 'components/Wizard/Card'
import Button from 'components/UI/Button'
import useContentAuthorize from 'hooks/api/useContentAuthorize'
import useShakaPlayer from 'hooks/useShakaPlayer'
import { getDefaultUserPath, t } from 'helpers'
import { getRedirectUrl, setRedirectUrl } from 'helpers/storage'
import { useUserStore } from 'store'
import s from './index.module.scss'

const Welcome = (): JSX.Element => {
	const navigate = useNavigate()
	const { hash } = useLocation()
	const user = useUserStore(useShallow((state) => state.user))
	const [playing, setPlaying] = useState(false)

	const redirect = (): void => {
		const redirectUrl = getRedirectUrl()
		if (redirectUrl) {
			navigate(redirectUrl)
			setRedirectUrl('')
		} else navigate(getDefaultUserPath(user?.CustomerRole))
	}

	const { data } = useContentAuthorize(
		hash?.includes('welcome')
			? '7bd843d4-58b3-43d4-998a-2cc03a8e3891'
			: undefined,
	)

	useShakaPlayer(
		data?.ContentUrl && hash.includes('welcome') ? data?.ContentUrl : null,
		'onboarding-welcome',
	)

	useEffect(() => {
		if (window.location.hash.includes('welcome')) {
			const video = document.getElementById(
				'onboarding-welcome',
			) as HTMLVideoElement
			if (video) video.muted = true
		}
		localStorage.setItem('isNewUser', 'true')
	}, [])

	return (
		<Card  noHint className={s.container}>
			<div className={s.layout}>
				{/* Left Text Box */}
				<div className={s.textBox}>
					<h2 className={s.title}>Welcome aboard!</h2>
					<p className={s.subtitle}>
						Thank you for joining us on this exciting journey! To help you get started,
						check out our Welcome Video that walks you through everything you need to know.
					</p>
					<Button variant="themed" onClick={redirect}>
						{t('APP_NEXT')}
					</Button>
				</div>
				<div className={s.videoBox}>
					<video
						id="onboarding-welcome"
						autoPlay
						controls
						onPlay={() => setPlaying(true)}
						onPause={() => setPlaying(false)}
						style={{ objectFit: 'cover', width: '100%',maxHeight:'380px', borderRadius: '16px' }}
					/>
					<div
						className={s.control}
						onClick={() => {
							const video = document.getElementById('onboarding-welcome') as HTMLVideoElement
							if (playing) video.pause()
							else video.play()
						}}
					>
						{playing ? <PauseIcon width="48" height="48" /> : <PlayIcon width="48" height="48" />}
					</div>
				</div>
			</div>
		</Card>
	)
}

export default Welcome
